import _ from 'lodash';

import { Location as HistLocation } from 'history';
import history from 'providers/history';
import { parse, stringify } from 'query-string';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import Router from 'react-router';

import NewsListingItem from 'components/pages/news/NewsListingItem';

import ResultsFooter from 'components/global/application/results_footer/ResultsFooter';
import { ArticlesApi } from 'providers/api';
import Log from 'providers/log';
import { Article, ArticleResponseData, GetArticleOptions, GetArticleOptionsKeys } from 'types/drupal/ArticleNode';

import 'components/pages/news/NewsListing.sass';

interface Props {
    match: Router.match<{}>;
    location: Location;
}

interface State {
    articlesLoaded: boolean;
    articlesResponse: ArticleResponseData;
}

class NewsletterListing extends React.Component<Props, State> {
    private unregisterHistoryListener: () => void;

    constructor(props: Props) {
        super(props);

        this.state = { articlesResponse: null, articlesLoaded: false };

        this.updateQueryString = this.updateQueryString.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    public componentDidMount() {
        this.updateData(this.props.location);
        this.unregisterHistoryListener = history.listen(location => this.updateData(location));
    }

    public componentWillUnmount() {
        this.unregisterHistoryListener();
    }

    public updateData(location: Location | HistLocation) {
        if (location.pathname !== '/newsletter') return;

        if (location.search.length < 0) {
            ArticlesApi.getNewsletters().then((data: ArticleResponseData) => {
                this.setState({
                    articlesLoaded: true,
                    articlesResponse: data
                });
            }).catch(reason => Log.error(reason));
        } else {
            let optionsPresentAndValid = false;
            const queryObj = parse(location.search);
            const queryKeys = Object.keys(queryObj);

            const passable_options: Partial<GetArticleOptions> = {};    // validate query keys discarding invalid keyValuePairs
            queryKeys.forEach((k: string) => {
                if (GetArticleOptionsKeys.indexOf(k) !== -1) {
                    const val = queryObj[k];
                    passable_options[k] = val; // === null ? true : val;
                    optionsPresentAndValid = true;
                }
            });

            if (optionsPresentAndValid) {
                ArticlesApi.getNewsletters(passable_options).then((data: ArticleResponseData) => {
                    this.setState(
                        {
                            articlesLoaded: true,
                            articlesResponse: data
                        },
                        () => {
                            if (
                                passable_options.hasOwnProperty('page')
                                && passable_options.page > this.state.articlesResponse.last_page
                            ) this.updateQueryString('page', this.state.articlesResponse.last_page.toString());
                        });
                }).catch(reason => Log.error(reason));

            } else {
                ArticlesApi.getNewsletters().then((data: ArticleResponseData) => {
                    this.setState({
                        articlesLoaded: true,
                        articlesResponse: data
                    });
                }).catch(reason => Log.error(reason));
            }
        }
    }

    public updateQueryString(key: string, value?: string) {
        const { location, match } = this.props;
        const queryUpdate = parse(location.search);
        queryUpdate[key] = value;   // set to undefined to remove during stringify
        const newQueryString = stringify(queryUpdate);
        history.push(`${match.url}${newQueryString.length > 0 ? `?${newQueryString}` : ''}`);
    }

    public render() {
        const { articlesResponse, articlesLoaded } = this.state;
        if (!articlesLoaded) return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);

        const { data: articles } = articlesResponse;
        return (
            <div className="NewsListing-container row">
                <div className="offset-md-1 col-md-10 NewsListing-col">
                    {articles.map((article: Article) => {
                        return <NewsListingItem
                            key={article.nid}
                            className="News-item"
                            title={article.title}
                            descriptionHml={article.body.value}
                            img={_.get(article, 'field_image.file.url')}
                            url={'/' + article.alias}
                        />;
                    })}
                    <ResultsFooter
                        currentPage={articlesResponse.current_page}
                        numPages={articlesResponse.last_page}
                        viewNumber={articlesResponse.per_page}
                        numResults={articlesResponse.total}
                        updateQueryString={this.updateQueryString}
                    />
                </div>
            </div>
        );
    }
}

export default NewsletterListing;



// WEBPACK FOOTER //
// ./src/components/pages/newsletter/NewsletterListing.tsx